export default __webpack_public_path__ + "static/media/logo.230aaea1.png";